import { render } from "./3d-4ma.vue?vue&type=template&id=380f5c22&scoped=true"
import script from "./3d-4ma.vue?vue&type=script&lang=js"
export * from "./3d-4ma.vue?vue&type=script&lang=js"

import "./3d-4ma.vue?vue&type=style&index=0&id=380f5c22&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380f5c22"]])

export default __exports__